import { useEffect, useState } from 'react';
import { TableColumn } from 'react-data-table-component';

import DigestDeleteModal from './Modals/DeleteDigestModal/DigestDeleteModal';

import AdvancedFilterDataTable from 'components/FilterDataTable/AdvancedFilterDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';
import CreateDigestReportModal from 'pages/VisitsAndScheduleTasks/Modals/createDigestReportModal/CreateDigestReportModal';
import { useGetDigestReportListTableColumns } from 'components/DigestReports/useGetVisitReportListTableColumns';
import useGetDigestReportsList from 'hooks/DigestReports/useGetDigestReportsList';
import { DigestReportData } from 'api/digestReports/getDigestReports';

interface VisitReportsPageProps {
  slug: string;
}

const DigestReportList: React.FC<VisitReportsPageProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetDigestReportsList({ slug: slug || '', enabled: false });
  const columns = useGetDigestReportListTableColumns(slug || '', refetch, data || []);
  const searchFields = ['created_by'];
  const { isNotDesktop } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white">
      <AdvancedFilterDataTable<DigestReportData>
        columns={columns as unknown as TableColumn<DigestReportData>[]}
        amountPerPageLabel="Reports Per Page"
        data={data || []}
        searchFields={searchFields}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotDesktop}
        isNotReportsTable={false}
      />
      <CreateDigestReportModal refetchPeriodReports={refetch} />
      <DigestDeleteModal />
    </div>
  );
};

export default DigestReportList;
